import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export default function SettingsModalContentWrapper(props) {
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h4", {
                className: "settings-modal-title",
                children: props.title
            }),
            props.children
        ]
    });
}
